/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOWInfoStateBody
 */
export interface CreateOWInfoStateBody {
    /**
     * Object containing game state information. Format comes from Overwolf's getInfo() function.
     * @type {object}
     * @memberof CreateOWInfoStateBody
     */
    data: object;
    /**
     * The source of the data (OVERWOLF_ELECTRON or OVERWOLF).
     * @type {string}
     * @memberof CreateOWInfoStateBody
     */
    source?: CreateOWInfoStateBodySourceEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOWInfoStateBody
     */
    pkgVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOWInfoStateBody
     */
    publicKey?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOWInfoStateBody
     */
    gameId?: number;
}


/**
 * @export
 */
export const CreateOWInfoStateBodySourceEnum = {
    OVERWOLF: 'OVERWOLF',
    OVERWOLF_ELECTRON: 'OVERWOLF_ELECTRON'
} as const;
export type CreateOWInfoStateBodySourceEnum = typeof CreateOWInfoStateBodySourceEnum[keyof typeof CreateOWInfoStateBodySourceEnum];


/**
 * Check if a given object implements the CreateOWInfoStateBody interface.
 */
export function instanceOfCreateOWInfoStateBody(value: object): value is CreateOWInfoStateBody {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateOWInfoStateBodyFromJSON(json: any): CreateOWInfoStateBody {
    return CreateOWInfoStateBodyFromJSONTyped(json, false);
}

export function CreateOWInfoStateBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOWInfoStateBody {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
        'source': json['source'] == null ? undefined : json['source'],
        'pkgVersion': json['pkgVersion'] == null ? undefined : json['pkgVersion'],
        'publicKey': json['publicKey'] == null ? undefined : json['publicKey'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
    };
}

export function CreateOWInfoStateBodyToJSON(json: any): CreateOWInfoStateBody {
    return CreateOWInfoStateBodyToJSONTyped(json, false);
}

export function CreateOWInfoStateBodyToJSONTyped(value?: CreateOWInfoStateBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
        'source': value['source'],
        'pkgVersion': value['pkgVersion'],
        'publicKey': value['publicKey'],
        'gameId': value['gameId'],
    };
}

